import { connect } from 'react-redux';
import store from 'js/store';
import { submitEventToValues } from 'js/helpers/form';
import { login } from 'js/store/actions/auth';
import LoginPage from '.';
export default connect(function (state, ownProps) {
  var _state$authForms$logi = state.authForms.login,
      isSubmitting = _state$authForms$logi.isSubmitting,
      errorMessage = _state$authForms$logi.errorMessage,
      successMessage = _state$authForms$logi.successMessage;
  var hasSelectedPlan;

  if (ownProps.selectedPlan) {
    if (ownProps.selectedPlan === ':cancel-subscription-success') hasSelectedPlan = {
      text: 'Subscription canceled!'
    };else if (ownProps.selectedPlan === ':premium') hasSelectedPlan = {
      text: 'Premium account created, login to start using COSMOS!'
    };else if (ownProps.selectedPlan === ':normal') hasSelectedPlan = {
      text: 'Standard account created, login to start using COSMOS!'
    };
  }

  return {
    isSubmitting: isSubmitting,
    messages: {
      error: errorMessage,
      success: successMessage || hasSelectedPlan
    },
    onSubmit: function onSubmit(event) {
      var values = submitEventToValues(event);
      store.dispatch(login(values));
    }
  };
})(LoginPage);